import {
  ShowContextProvider,
  ShowView,
  TextField,
  useShowController,
} from "react-admin";

const BankOneSpanAccountShow = () => {
  const controllerProps = useShowController();
  return (
    <ShowContextProvider value={controllerProps}>
      <ShowView title="OneSpan Account">
        <TextField source="sEmail" label="Email" />
        <TextField source="sFirstName" label="First Name" />
        <TextField source="sLastName" label="Last Name" />
      </ShowView>
    </ShowContextProvider>
  );
};

export default BankOneSpanAccountShow;
